
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import NbNewUploadedFile from "@/components/NewFileUploader/NbNewUploadedFile.vue";

const MESSAGES = {
  addMore: "Add more",
};

@Component({
  components: {
    NbNewUploadedFile,
  },
})
export default class NbNewUploaderFilesList extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly files?: any;
  @Prop({ type: String, default: "" }) readonly documentType!: string;

  MESSAGES = MESSAGES;

  get sortedFilesByErrors() {
    return this.files.sort((a, b) => {
      return a.errors.length > b.errors.length ? -1 : 1;
    });
  }

  get sortedFiles() {
    return this.sortedFilesByErrors.sort((a, b) => {
      return a.loading > b.loading ? -1 : 1;
    });
  }

  downloadFile() {
    console.log("downloadFile");
  }

  archiveFile() {
    console.log("archiveFile");
  }

  deleteFile(file, fileIndex) {
    this.selected = null;

    this.$emit("delete", {
      payload: file,
      index: fileIndex,
    });
  }

  selected = null;

  isSelected(file) {
    return this.selected === file;
  }

  viewFile(payload, index) {
    this.selected = payload;

    this.$emit("select", { payload, index });
  }

  @Watch("files", { deep: true, immediate: true })
  isOpenChanged(items) {
    if (items.length === 1) this.viewFile(items[0], 0);
  }
}
